<div class="issue-confirmation"
     [attr.data-testid]="testId()">
  <app-section-header [title]="headerTitle()"
                      [showBack]="true"
                      align="center"
                      (back)="back.emit()"
                      [testId]="testId() + '-header'" />

  <app-issue-card [issue]="issue()"
                  [media]="media()"
                  [showCheckbox]="false"
                  [testId]="testId() + '-card'" />

  <form [formGroup]="form"
        class="issue-confirmation-form"
        [attr.data-testid]="testId() + '-form'">
    <app-form-field label="Severity"
                    [required]="true"
                    [invalid]="severityInvalid()"
                    [control]="form.controls.severity"
                    [errorMessages]="{ required: 'Severity is required' }"
                    [attr.data-testid]="testId() + '-severity-field'">
      <app-horizontal-button-group [buttons]="severityButtons()"
                                   [testId]="testId() + '-severity-levels'" />
      <app-severity-info [severity]="severity()"
                         [testId]="testId() + '-severity-info'" />
    </app-form-field>


  </form>
</div>
